import { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import H1 from "@/components/ui/H1";
import { cn } from "@/util/cn";

interface PanelCardProps {
  title?: string;
  children: ReactNode;
  variant?: "default" | "teal";
  className?: string;
  contentClassName?: string;
}

export const PanelCard: React.FunctionComponent<PanelCardProps> = ({
  title,
  children,
  variant = "default",
  className,
  contentClassName,
}) => {
  const cardClasses =
    variant === "teal"
      ? "w-full bg-brand-blue-200 rounded-4xl py-12"
      : "w-full bg-brand-neutral-900 rounded-4xl py-12";

  const titleClasses =
    variant === "teal" ? "text-center text-black" : "text-center";

  const textClasses = variant === "teal" ? "text-black" : "text-white";

  return (
    <Card className={cn(cardClasses, className)}>
      {title && (
        <CardHeader>
          <CardTitle>
            <H1 className={titleClasses}>{title}</H1>
          </CardTitle>
        </CardHeader>
      )}
      <CardContent className={cn("md:px-16", textClasses, contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
};

export default PanelCard;
